import { Route, Routes } from 'react-router-dom';
import { PublicLayout } from './layout/PublicLayout.js';
import { NotFoundView } from './modules/shared/views/NotFoundView.js';
import { ssrRoutes } from './modules/shared/ssr/ssr-routes.js';

/**
 * Router del sitio público. Las rutas salen de `ssrRoutes` (misma fuente que usa el
 * server para elegir el loader), así el cliente y el server nunca divergen.
 */
export function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        {ssrRoutes.map((r) =>
          r.path === '/' ? (
            <Route key={r.key} index element={r.element} />
          ) : (
            <Route key={r.key} path={r.path} element={r.element} />
          ),
        )}
        <Route path="*" element={<NotFoundView />} />
      </Route>
    </Routes>
  );
}
